import React from "react";
import { Container } from "aurelia-dependency-injection";
import { StoresContext } from "../Contexts";
import { GlobalStores } from "../Contexts/StoresContext";

export const useStores = (): GlobalStores => {
  const storesContext = Container.instance.get(StoresContext);
  return React.useContext(storesContext.context);
};
